module.exports = __webpack_public_path__ + "static/media/comboOnPalpationPad.9ba76920.jpg";